/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { AreaFragmentCombinationDeclarationDto } from "./AreaFragmentCombinationDeclarationDto";
import { Side } from "../Side";

export class AreaFragmentCombinationDeclarationGroupDto {
    id: string;
    minWidth: number;
    maxWidth: number;
    areaFragmentCombinationDeclarations: AreaFragmentCombinationDeclarationDto[];
    readableName: string;
    side: Side;
    organisationId: string;
    configurationTemplateId: string;
    faceConfigurationId: string;
}
